import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {siteCountryFromLocale} from '../utils/optimizely-attributes'
import {expPageView, startExpBehaviourTracking} from '../utils/optimizely-exp-behaviour'

/*
 * Mounts the dual behavioural listeners once on the client and reports every
 * route change as a page view. Not gated on FX: WebX still needs navigation /
 * cta / time_on_page when Feature Experimentation is off. Effects only.
 */
export function useOptimizelyExpBehaviour() {
    const {locale} = useMultiSite()
    const localeId = locale?.id || locale?.alias || 'en-CA'
    const {pathname} = useLocation()

    useEffect(() => {
        startExpBehaviourTracking({siteCountry: siteCountryFromLocale(localeId)})
    }, [localeId])

    useEffect(() => {
        expPageView(pathname)
    }, [pathname])
}
